<td><a class="fw-500" (click)="edit_Task(task)">{{task.task_name | truncate : 50:'...'}}</a></td>
<td class="text-capitalize">{{task.assigned_to_name}}</td>
<td class="text-capitalize">{{task.assigned_by_name}}</td>
<td class="text-capitalize" *ngIf="!isPatientProfile">{{task.patient.name ? task.patient.name:"None" }}</td>
<td class="text-center">{{task.priority}}</td>
<td class="text-center">
  <span [ngClass]="task.after_due_date_color ">
    {{task.due_date |  date:'mediumDate'}}
  </span>
</td>
<td class="text-center">
  <label *ngIf="task.status_id == 'Not Started'" class="label label-danger m0">{{task.status_id}}</label>
  <label *ngIf="task.status_id == 'In Progress'" class="label label-info m0">{{task.status_id}}</label>
  <label *ngIf="task.status_id == 'Completed'" class="label label-success m0">{{task.status_id}}</label>
</td>
<td>
  <a class="btn btn-secondary btn-outline mr" tooltip="Send Instant Message" (click)="send_message(task)" *ngIf="task.assigned_to != task.assigned_by">
    <i class="fa fa-comment-o"></i>
  </a>
  <a class="btn btn-secondary btn-outline" tooltip="Mark Task Completed" (click)="markCompleted()" *ngIf="!(task.status_id == 'Completed')">
    <i class="fa icon-check vl-m"></i>
  </a>
</td>
